import { FilterState } from '@components/cockpit/panels/sensorInstallation/useSensorFilterState';
import { CategoryEnum, ReverseSensorShorthand, SensorShorthand } from '@utils/sensors/configuration.constants';
import { groupBy, merge } from 'lodash';

import {
  GetSensorOrSubSensorConfigurationWithShorthand,
  SensorTypeWithShorthand,
} from '@/types/sensor/sensorInstallation.types';

export function getEnabledSensorTypes(state: FilterState) {
  const enabledTypes = new Set<SensorTypeWithShorthand>();
  if (state.categories.has(CategoryEnum.PERIM) || state.categories.size === 0) {
    state.perimeterSensors.forEach((enabled, abbr) => {
      if (enabled) enabledTypes.add(ReverseSensorShorthand[abbr]);
    });
  }
  if (state.categories.has(CategoryEnum.LAD) || state.categories.size === 0) {
    state.ladSensors.forEach((enabled, abbr) => {
      if (enabled) enabledTypes.add(ReverseSensorShorthand[abbr]);
    });
  }
  return enabledTypes;
}

export function filterSensorsWithoutStatusFilter(
  sensors: GetSensorOrSubSensorConfigurationWithShorthand<SensorTypeWithShorthand>[],
  enabledTypes: Set<SensorTypeWithShorthand>,
) {
  return sensors.filter(
    (sensor) => enabledTypes.size === 0 || enabledTypes.has(sensor.type as SensorTypeWithShorthand),
  );
}

export function groupAndEnsureKeys(
  sensors: GetSensorOrSubSensorConfigurationWithShorthand<SensorTypeWithShorthand>[],
  enabledTypes: Set<SensorTypeWithShorthand>,
) {
  const grouped = groupBy(sensors, (sensor) => sensor.type as SensorTypeWithShorthand) as Record<
    SensorTypeWithShorthand,
    GetSensorOrSubSensorConfigurationWithShorthand<SensorTypeWithShorthand>[]
  >;

  const defaultGrouped = Object.fromEntries([...enabledTypes].map((type) => [type, []]));
  return merge(defaultGrouped, grouped);
}

export function sortAndConvertToMap(
  grouped: Record<SensorTypeWithShorthand, GetSensorOrSubSensorConfigurationWithShorthand<SensorTypeWithShorthand>[]>,
) {
  const sortedKeys = Object.keys(grouped).sort((a, b) =>
    SensorShorthand[a as SensorTypeWithShorthand].localeCompare(SensorShorthand[b as SensorTypeWithShorthand]),
  );
  return new Map(sortedKeys.map((key) => [key as SensorTypeWithShorthand, grouped[key as SensorTypeWithShorthand]]));
}
